<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12" class="text-right">
        <CButton type="button" color="success" size="sm" @click="mtdExportData">
          <i class="fas fa-file-excel"></i> Descargar excel
        </CButton>
      </CCol>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12" class="mt-2">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Clientes"
          icon="fas fa-coins"
          btn_name="Cliente"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtdSyncro="mtdSyncro"
        />
      </CCol>
    </CRow>
    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow class="flex">
        <CCol xl="10" lg="10" md="10" sm="10" xs="10" class="col-9">
          <CInput
            label="Documento de cliente"
            v-model="client.document"
            placeholder="Documento de identidad"
            v-on:keypress="isNumber($event)"
            @keypress.enter="mtdDocumentClient"
          />
        </CCol>
        <CCol xl="2" lg="2" md="2" sm="2" xs="2" class="mt-1 my-auto col-3">
          <CButton
            class="w-100 mt-2"
            color="info"
            v-c-tooltip.hover="{ content: `Buscar documento` }"
            @click="mtdDocumentClient"
          >
            <i class="fas fa-search"></i>
          </CButton>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="client.name"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Telefono"
            placeholder="Digite telefono"
            v-model="client.phone"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Correo"
            placeholder="Digite correo"
            v-model="client.email"
            @input="validateEmail(client.email)"
          />
          <span v-if="errors.email" class="text-danger">{{
            errors.email
          }}</span>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Dirección"
            placeholder="Digite dirección"
            v-model="client.address"
          />
        </CCol>
        <!-- <CCol sm="12">
          <CInput
            type="date"
            label="Fecha de Nac."
            placeholder="Digite nombre"
            v-model="client.fech_nacimiento"
          />
        </CCol> -->
        <CCol lg="6" md="6" sm="12">
          <CSelect
            label="Mes"
            :value.sync="client.month"
            :options="months"
            placeholder="--Seleccione un mes--"
          />
        </CCol>
        <CCol lg="6" md="6" sm="12">
          <CInput
            label="Día"
            type="number"
            v-model="client.day"
            min="1"
            max="31"
            placeholder="Día"
          ></CInput>
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="client.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Cliente'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "document", label: "Documento", _style: "width:20%;" },
  { key: "phone", label: "Telefono", _style: "width:20%;" },
  { key: "email", label: "Correo", _style: "width:20%;" },
  // { key: "address", label: "Dirección", _style: "width:20%;" },
  {
    key: "fech_nacimiento",
    label: "Fecha de Cumpleaños",
    _style: "width:20%;",
  },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import CModalForm from "../shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },
  data() {
    return {
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      prefix: "client",
      fields,
      data: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      client: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        name: "",
        address: "",
        document: "",
        phone: "",
        email: "",
        // fech_nacimiento: "",
        day: "",
        month: null,
        state: 0,
      },
      errors: {
        email: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      myButtons: [
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Fecha de cumpleaños",
          action: "mtdSyncro",
          icon: "fas fa-calendar",
          show: {
            value: "boo_nacimiento",
          },
        },
      ],
    };
  },
  computed: {
    cp_button: function () {
      return !(this.client.name !== "" && this.client.document !== "");
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo(a) Cliente")
        : (this.modal.title = "Editar Cliente");
      if (action == "store") {
        this.client = {
          id: "",
          company_id: this.$store.getters.get_company.id,
          name: "",
          address: "",
          document: "",
          phone: "",
          email: "",
          day: "",
          month: "",
          // fech_nacimiento: "",
          state: "",
        };
        this.errors = {
          email: "",
        };
      } else {
        this.client = this.client;
        if (this.client.fech_nacimiento) {
          const [month, day] = this.client.fech_nacimiento.split("-");
          this.client.day = day;
          this.client.month = this.months[parseInt(month, 10) - 1];
        }
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: this.client,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({ title: "Cliente ya registrado", icon: "warning" });
          } else if (response.statusCode == 200) {
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            const color = "success";
            if (this.modal.action == "store") {
              this.mtd_getdata();
            } else {
              this.data = this.data.map((element) =>
                element.Id === response.data[0].Id
                  ? { ...element, ...response.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
            }
            this.modal = { action: "", title: "", modal_form: false };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "warning",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.client = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.client.state = payload == true ? 1 : 0;
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == this.client.email) {
        if (!emailPattern.test(email)) {
          this.errors.email =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email = "";
        }
      }
    },
    mtdDocumentClient: function () {
      if (this.client.document.length === 0) {
        Swal.fire({
          title: "El número de documento no debe estar vacío",
          icon: "error",
        });
        return;
      }

      if (this.client.document.length === 9) {
        this.mtdSearchClientByCE();
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url +
          "/cita/cliente/" +
          this.$store.getters.get_company.id +
          "/" +
          this.client.document,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.state === 0) {
          if (
            this.client.document.length === 8 ||
            this.client.document.length === 11
          ) {
            this.mtdSearchDocument();
          } else {
            this.client.name = "";
          }
        } else if (response.statusCode === 200 && response.data.state === 1) {
          this.client.name = response.data.data.name;
        }
      });
    },
    mtdSearchClientByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.client.document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode === 204) {
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
          this.clearClientData();
          return;
        }

        this.client.name = response.data.name;
      });
    },
    mtdSearchDocument: function () {
      if (
        this.client.document.length !== 8 &&
        this.client.document.length !== 11
      ) {
        Swal.fire({
          title: "Documento inválido",
          icon: "error",
        });
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url + "/Consultas/" + this.client.document,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo === 3) {
            this.clearClientData();
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.populateClientData(response.data);
          }
        })
        .catch((error) => {
          console.error("Error al consultar el documento:", error);
          Swal.fire({
            title: "Error en la solicitud",
            text: "Por favor, intente nuevamente más tarde.",
            icon: "error",
          });
        });
    },
    clearClientData: function () {
      this.client.name = "";
      this.client.address = "";
    },
    populateClientData: function (data) {
      if (this.client.document.length === 8) {
        this.client.name = `${data.name} ${data.last_name}`;
      } else {
        this.client.name = data.razon_social;
      }
      this.client.address = data.direccion;
    },
    mtdSyncro: function (item) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/update/date/" +
          item.document,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.mtd_getdata();
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    /** export excel */
    mtdExportData: function () {
      // 1. Cabeceras (labels)
      const headers = this.fields.map((f) => f.label);

      // 2. Keys (para extraer datos)
      const keys = this.fields.map((f) => f.key);

      // 3. Data formateada
      const rows = this.data.map((item, index) => {
        return keys.map((key) => {
          if (key === "index") return index + 1;
          return item[key] ?? "";
        });
      });

      // 4. Crear hoja
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

      // 5. Crear libro
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

      // 6. Exportar
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(file, "clientes.xlsx");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
